import styled from 'styled-components';

import { Clickable } from '@catalyze/ui';

export const ButtonsContainer = styled.div`
    display: flex;
    column-gap: 0.5rem;
`;

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 700;
`;

export const DeleteEDM = styled(Clickable)`
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.formError};
    font-size: ${({ theme }) => theme.fontSizes[2]};
    font-weight: 400;
`;
